<script setup lang="ts">
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { onBeforeMount, reactive, ref, toRefs } from "vue";
import Button from "../../../base-components/Button";
import { FormInput, FormLabel } from "../../../base-components/Form";
import LoadingIcon from "../../../base-components/LoadingIcon";
import Preview from "../../../base-components/Preview";
import { userUserStore } from "../../../stores/user";
import OpcionesGeneralesFiservPos from "./OpcionesGeneralesFiservPos.vue";
import { IFiservConfig, IFiservPOSConfig } from "@fixeduy/restaurantestypes";

// import { useLocalesStore } from "../../../services/locales";

const userStore = userUserStore();
// const localesStore = useLocalesStore();

const emit = defineEmits<{ (e: "cerrar"): void }>();

const cargando = ref<boolean>(false);

const formData = reactive({
  SystemId: userStore.opcionesGenerales.integracionPOSFiserv.SystemId,
  integracionFiservPOS: userStore.opcionesGenerales.integracionPOSFiserv.pos
});

const rules = {
  SystemId: {
    required: helpers.withMessage(
      "El campo SystemId no puede estar vacío",
      required
    )
  },
  integracionFiservPOS: {
    required: helpers.withMessage("Debes cargar al menos un pos", required)
  }
};

const validate = useVuelidate(rules, toRefs(formData));

const agregarPosVacio = () => {
  formData.integracionFiservPOS.push({
    nombre: "",
    local: "",
    PosID: "",
    Plan: "",
    Branch: "",
    ClientAppId: "",
    imprime: true,
    taxRefund: "0"
  });
};

onBeforeMount(() => {
  if (formData.integracionFiservPOS.length == 0) {
    agregarPosVacio();
  }
});

const actualizarPOS = (params: { indice: number; pos: IFiservPOSConfig }) => {
  formData.integracionFiservPOS[params.indice] = params.pos;
};

const handlerGuardar = async () => {
  const result = await validate.value.$validate();
  if (result) {
    const config: IFiservConfig = {
      SystemId: formData.SystemId,
      habilitado: userStore.opcionesGenerales.integracionPOSFiserv.habilitado,
      pos: formData.integracionFiservPOS
    };
    userStore.setOpcionesFiserv(config);
    cargando.value = false;
    emit("cerrar");
  }
};
</script>

<template>
  <Preview class="box mt-5">
    <form class="validate-form p-4" @submit.prevent="">
      <div
        class="border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400"
      >
        <div
          class="w-full pb-6 cursor-pointer flex-row flex"
          @click="
            () => {
              emit('cerrar');
            }
          "
        >
          <div class="flex w-full justify-center mt-2">
            <h1 class="self-center text-xl mt-2">Opciones Fiserv</h1>
          </div>
        </div>

        <!-- SystemId  -->
        <div class="col-span-12 lg:col-span-6 mt-3 mb-5">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel htmlFor="horizontal-form-1" class="w-40 sw:w-20">
                SystemId
              </FormLabel>
            </div>
            <div>
              <FormInput
                type="text"
                v-model.trim="formData.SystemId"
                placeholder="SystemId"
              />
            </div>
          </div>
        </div>

        <hr />
        <p class="p-5">Configuración del Pos</p>
        <hr />
        <template v-for="(pos, index) in formData.integracionFiservPOS">
          <OpcionesGeneralesFiservPos
            :pos="pos"
            :indice="index"
            @actualizar="actualizarPOS"
          />
        </template>
        <Button
          variant="secondary"
          class="mb-2 mr-1 mt-5"
          @click="agregarPosVacio"
        >
          Agregar pos
        </Button>

        <div v-if="!cargando" class="flex mt-10">
          <div class="flex-1 text-left mt-3">
            <Button
              variant="secondary"
              class="mb-2 mr-1"
              @click="() => emit('cerrar')"
            >
              Cancelar
            </Button>
          </div>
          <div class="flex-1 text-right">
            <Button
              variant="primary"
              class="mb-2 mr-1 mt-3"
              @click="handlerGuardar"
            >
              Guardar
            </Button>
          </div>
        </div>
        <div v-else class="flex my-6">
          <div class="mx-auto">
            <LoadingIcon icon="oval" class="w-8 h-8" />
          </div>
        </div>
      </div>
    </form>
  </Preview>
</template>
